var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"similar-clients-list"},[_c('p',[_vm._v("Review similar clients")]),(!_vm.clientName.length || !_vm.filteredEmployerList.length)?_c('div',{staticClass:"similar-clients"},[_c('p',[_vm._v("Check here to confirm this is a new client")])]):_c('ul',_vm._l((_vm.filteredEmployerList),function(ref){
var id = ref.id;
var name = ref.name;
return _c('li',{key:name},[_c('router-link',{attrs:{"to":{
          name: 'ClientOverview',
          params: { clientId: id }
        },"target":"_blank"}},[_vm._v(" "+_vm._s(name)+" "),_c('tf-button',{attrs:{"type":"primary","icon":"external-link-alt","no-padding":"","no-branding":"","size":"icon-no-fill"}})],1)],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }